import Swal from "sweetalert2";

import i18n from "../locales/i18n";

async function saveHandler(
  values: any,
  { setSubmitting }: any,
  callback: Function
) {
  Swal.fire({
    title: i18n.t("actions.want_to_save_changes"),
    showCancelButton: true,
    icon: "info",
    reverseButtons: true,
    cancelButtonText: i18n.t("actions.cancel"),
    confirmButtonText: i18n.t("actions.save"),
  }).then((result) => {
    /* Read more about isConfirmed, isDenied below */
    if (result.isConfirmed) {
      callback(values, { setSubmitting });
    } else {
      setSubmitting(false);
      Swal.fire(i18n.t("actions.changes_not_saved"), "", "info");
    }
  });
}

export default saveHandler;
